import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import { getGlobalEntityList
 } from './GetListRequests';
import GlobalEntity from './GlobalEntity';

class GlobalEntityList extends Component {
  state = { 
    globalEntityList : null,
  }

  callBackGetGlobalEntity = (response) => {
    
    const {data} = response;
    const {statusCode} = data;

    switch(statusCode) {
      case 200:
      const {property} = data;
      const {globalEntityList} = property;
      
      this.setState({
        globalEntityList : globalEntityList,
      });
      break;

      case 403:
      alert("서버에서 거부하였습니다.");
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
      break;
    }
  }

  componentDidMount() {
    const { callBackGetGlobalEntity } = this;
    getGlobalEntityList(callBackGetGlobalEntity, 0);
  }

  renderGlobalEntityList = (globalEntityList) => {
    if (!globalEntityList) {
      return null;
    }
    return globalEntityList.map( (globalEntity, i) => {
      const {entity_name} = globalEntity;
      const {entity_value} = globalEntity;

      return (
        <GlobalEntity
          key={i}
          entityName={entity_name}
          entityArray={entity_value}
        />
      )
    });
  }

  render() {
    const { globalEntityList } = this.state;
    const renderedGlobalEntityList = this.renderGlobalEntityList(globalEntityList);

    return (
      <div className="entity-list">
        <div className="loading-icon-wrapper">
          {
            globalEntityList ?
              renderedGlobalEntityList :
              <ReactLoading type={"spinningBubbles"} color="gray" />
          }
        </div>
      </div>
    );
  }
}

export default GlobalEntityList;